module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ng-caaf41205a6fde2a18533c696a971248.svg";